import { RepeatType, normalizeFieldInfo } from '@protobuf-ts/runtime'

import type { IMessageType, FieldInfo } from '@protobuf-ts/runtime'

/**
 * @internal
 *
 * Creates a normalized FieldInfo object for the provided message.
 */
export function createMessageFieldInfo<T extends IMessageType<object>> (message: T): FieldInfo {
  return normalizeFieldInfo({
    no: 1,
    name: message.typeName,
    kind: 'message',
    T: () => message,
  })
}

type OneofKind<T extends string, U> = {
  oneofKind: T
} & {
  [K in T]: U
}
/**
 * @internal
 *
 * Helper to write a oneof field that is strongly typed.
 *
 * @example
 * const source = writeOneofKind(
 *   configValue.source,
 *   writeOrMap(InputData_Common, configValue)!,
 * )
 */
export function writeOneofKind<T extends string, U> (oneofKind: T, value: U): { [K in T]: OneofKind<K, U> }[T] {
  // @ts-expect-error(required): TS cannot infer which is why we have this util
  return {
    oneofKind,
    [oneofKind]: value,
  }
}

/**
 * Returns a new object, merging the defaults with any provided values already on the program configuration object.
 * This will replace any not defined values only.
 */
export function setDefaults<T extends object> (config: T, defaults: () => Partial<T>): T {
  return {
    ...defaults(),
    ...config,
  }
}

/**
 * Returns `true` if the provided FieldInfo is an array (repeated).
 */
export function isArrayFieldInfo (fieldInfo: FieldInfo): boolean {
  return fieldInfo.repeat === RepeatType.PACKED || fieldInfo.repeat === RepeatType.UNPACKED
}
